import axios from 'axios';
import {
    IS_PRODUCTION_ENVIRONMENT,
    LOCALHOST_API_URL,
    DEVELOPMENT_API_URL
    } from '../helpers/constants';

// API URL
if (IS_PRODUCTION_ENVIRONMENT) {
  axios.defaults.baseURL = LOCALHOST_API_URL
}else {
  axios.defaults.baseURL = DEVELOPMENT_API_URL;
}
